/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useContext } from 'react';
import { Card, Col, Row, Container, Table } from 'react-bootstrap';
import { Text, Stack, Group, Space, Center, Button, Tabs, Switch } from '@mantine/core';
import { Pagination, Badge } from '@mantine/core';
import { TextInput } from '@mantine/core';
import {
  IconSearch,
  IconCopy,
  IconEdit,
  IconTrash,
  IconPhoto,
  IconMessageCircle,
  IconRefresh,
  IconArrowsSort,
  IconSortAscending,
  IconSortDescending,
} from '@tabler/icons';
import { ActionIcon } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { IconPlus } from '@tabler/icons';
import AddMaterial from '../ProjectRequest/AddMaterial';
import { UserContext } from '../../context/userContext';
import CustomCardLoader from '../../components/CustomCardLoader';
import moment from 'moment';
import { pageContext } from '../../context/pageContext';
import homeServices from '../../services/homeServices';
import { DateDifference, RowColors, formatChange } from '../../utils/Utils';

function MDMView1() {
  const navigate = useNavigate();

  const {
    searchMdmView1,
    setSearchMdmView1,
    mdmViewPagination1,
    setMdmViewPagination1,
    totalMdmView1,
    setTotalMdmView1,
  } = useContext(pageContext);

  // const [projectList, setProjectList] = useState([]);

  // useEffect(() => {
  //   let temp = [];
  //   projects?.map((project) => {
  //     project?.materials?.map((material) => {
  //       material.plants?.map((plant) => {
  //         temp.push({
  //           ...plant,
  //           project_type: project?.project_type,
  //           project_name: project?.project_name,
  //           project_year: project?.project_year,
  //           project_owner: project?.project_owner,
  //           material_status: material?.material_status,
  //           material_id: material?.id,
  //           sku_description: material?.sku_description,
  //           fg_type: material?.fg_type,
  //           liquid: material?.liquid,
  //           m_deleted: material?.deleted,
  //           deleted: material?.deleted,
  //           pl_deleted: plant?.deleted,
  //           pr_deleted: project?.deleted,
  //           plant: plant?.plant,
  //           plant_status: plant?.status,
  //           plant_id: plant?.id,
  //           virtual_sku_description: material?.virtual_sku_description,
  //         });
  //       });
  //     });
  //   });

  //   console.log(
  //     'temp FILTERED 3.1',
  //     temp?.filter((item) => item?.material_status == 3),
  //   );
  //   setProjectList(
  //     temp?.filter((item) => item?.material_status == 3)?.filter((item) => item?.deleted === false),
  //   );
  // }, [projects]);

  const [projectList, setProjectList] = useState([]);
  const [pages, setPages] = React.useState(0);
  const [loadingData, setLoadingData] = useState(false);
  const [sortedColumnData, setSortedColumnData] = useState(null);
  const [sortType, setSortType] = useState(null);

  const fetchData = async (offset, search, sort_column = null, sort_type = null) => {
    setSortedColumnData(sort_column);
    setSortType(sort_type);
    setLoadingData(true);
    homeServices
      .getSkuIdCreationData({
        search: search,
        offset: (offset - 1) * 10,
        sort_column: sort_column,
        sort_type: sort_type,
      })
      .then((res) => {
        // console.log('PROJECT REQUEST DATA: ', res);
        setProjectList(res?.data);
        setPages(res?.total);
        setLoadingData(false);
        setTotalMdmView1(res?.rows);
      })
      .catch((err) => {
        // console.log('PROJECT REQUEST ERROR: ', err);
      });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchData(1, searchMdmView1);
    }, 1500);
    return () => clearTimeout(timer);
  }, [searchMdmView1]);

  return (
    <div style={{ marginLeft: '1rem', marginRight: '1rem' }}>
      <Card radius="xl">
        <Card.Body>
          <Group position="apart">
            <Text size="xl" weight={700} color="yellow" align="left" style={{ fontSize: '18px' }}>
              {}
            </Text>
          </Group>
        </Card.Body>
        <Card.Body>
          <Group position="apart">
            <Text
              size="xl"
              weight={700}
              color="yellow"
              style={{ fontSize: '18px' }}
            >{`SKU ID Creation`}</Text>
          </Group>
          <Space h="xl" />
          <TextInput
            radius={'xl'}
            placeholder={`SKU Description`}
            sx={{ width: '16vw' }}
            rightSection={
              <ActionIcon
                variant="filled"
                color={'yellow'}
                radius="xl"
                size="md"
                onClick={() => {
                  setSearchMdmView1('');
                  setMdmViewPagination1(1);
                }}
              >
                <IconRefresh size={14} color="black" />
              </ActionIcon>
            }
            onChange={(e) => {
              setLoadingData(true);
              setSearchMdmView1(e.target.value);
              setMdmViewPagination1(1);
            }}
            value={searchMdmView1}
          />
        </Card.Body>
        {loadingData ? (
          <CustomCardLoader />
        ) : (
          <div className="table-responsive-sm">
            <Table hover>
              <thead>
                <tr>
                  <th>
                    <Center fw={500}>
                      Type
                      <>
                        {sortedColumnData !== 'Type' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1, 'Type', 'ascending');
                            }}
                          >
                            <IconArrowsSort />
                          </ActionIcon>
                        )}
                        {sortedColumnData == 'Type' && sortType == 'ascending' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1, 'Type', 'descending');
                            }}
                          >
                            <IconSortAscending />
                          </ActionIcon>
                        )}
                        {sortedColumnData == 'Type' && sortType == 'descending' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1);
                            }}
                          >
                            <IconSortDescending />
                          </ActionIcon>
                        )}
                      </>
                    </Center>
                  </th>
                  <th>
                    <Center fw={500}>
                      Project Name
                      <>
                        {sortedColumnData !== 'Project Name' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1, 'Project Name', 'ascending');
                            }}
                          >
                            <IconArrowsSort />
                          </ActionIcon>
                        )}
                        {sortedColumnData == 'Project Name' && sortType == 'ascending' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1, 'Project Name', 'descending');
                            }}
                          >
                            <IconSortAscending />
                          </ActionIcon>
                        )}
                        {sortedColumnData == 'Project Name' && sortType == 'descending' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1);
                            }}
                          >
                            <IconSortDescending />
                          </ActionIcon>
                        )}
                      </>
                    </Center>
                  </th>
                  <th>
                    <Center fw={500}>
                      SKU Description
                      <>
                        {sortedColumnData !== 'Sku Description' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1, 'Sku Description', 'ascending');
                            }}
                          >
                            <IconArrowsSort />
                          </ActionIcon>
                        )}
                        {sortedColumnData == 'Sku Description' && sortType == 'ascending' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1, 'Sku Description', 'descending');
                            }}
                          >
                            <IconSortAscending />
                          </ActionIcon>
                        )}
                        {sortedColumnData == 'Sku Description' && sortType == 'descending' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1);
                            }}
                          >
                            <IconSortDescending />
                          </ActionIcon>
                        )}
                      </>
                    </Center>
                  </th>
                  <th>
                    <Center fw={500}>
                      Hold
                      <>
                        {sortedColumnData !== 'Hold' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1, 'Hold', 'ascending');
                            }}
                          >
                            <IconArrowsSort />
                          </ActionIcon>
                        )}
                        {sortedColumnData == 'Hold' && sortType == 'ascending' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1, 'Hold', 'descending');
                            }}
                          >
                            <IconSortAscending />
                          </ActionIcon>
                        )}
                        {sortedColumnData == 'Hold' && sortType == 'descending' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1);
                            }}
                          >
                            <IconSortDescending />
                          </ActionIcon>
                        )}
                      </>
                    </Center>
                  </th>

                  <th>
                    <Center fw={500}>
                      FG Type
                      <>
                        {sortedColumnData !== 'Fg Type' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1, 'Fg Type', 'ascending');
                            }}
                          >
                            <IconArrowsSort />
                          </ActionIcon>
                        )}
                        {sortedColumnData == 'Fg Type' && sortType == 'ascending' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1, 'Fg Type', 'descending');
                            }}
                          >
                            <IconSortAscending />
                          </ActionIcon>
                        )}
                        {sortedColumnData == 'Fg Type' && sortType == 'descending' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1);
                            }}
                          >
                            <IconSortDescending />
                          </ActionIcon>
                        )}
                      </>
                    </Center>
                  </th>
                  <th>
                    <Center fw={500}>
                      Production Date
                      <>
                        {sortedColumnData !== 'Production Date' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1, 'Production Date', 'ascending');
                            }}
                          >
                            <IconArrowsSort />
                          </ActionIcon>
                        )}
                        {sortedColumnData == 'Production Date' && sortType == 'ascending' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1, 'Production Date', 'descending');
                            }}
                          >
                            <IconSortAscending />
                          </ActionIcon>
                        )}
                        {sortedColumnData == 'Production Date' && sortType == 'descending' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1);
                            }}
                          >
                            <IconSortDescending />
                          </ActionIcon>
                        )}
                      </>
                    </Center>
                  </th>
                  <th>
                    <Center fw={500}>
                      Due Date
                      <>
                        {sortedColumnData !== 'Due Date' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1, 'Due Date', 'ascending');
                            }}
                          >
                            <IconArrowsSort />
                          </ActionIcon>
                        )}
                        {sortedColumnData == 'Due Date' && sortType == 'ascending' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1, 'Due Date', 'descending');
                            }}
                          >
                            <IconSortAscending />
                          </ActionIcon>
                        )}
                        {sortedColumnData == 'Due Date' && sortType == 'descending' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1);
                            }}
                          >
                            <IconSortDescending />
                          </ActionIcon>
                        )}
                      </>
                    </Center>
                  </th>
                  <th>
                    <Center fw={500}>
                      Days To Production
                      <>
                        {sortedColumnData !== 'Days To Production' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1, 'Days To Production', 'ascending');
                            }}
                          >
                            <IconArrowsSort />
                          </ActionIcon>
                        )}
                        {sortedColumnData == 'Days To Production' && sortType == 'ascending' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1, 'Days To Production', 'descending');
                            }}
                          >
                            <IconSortAscending />
                          </ActionIcon>
                        )}
                        {sortedColumnData == 'Days To Production' && sortType == 'descending' && (
                          <ActionIcon
                            onClick={() => {
                              fetchData(1, searchMdmView1);
                            }}
                          >
                            <IconSortDescending />
                          </ActionIcon>
                        )}
                      </>
                    </Center>
                  </th>
                </tr>
              </thead>
              <tbody>
                {projectList?.map((project, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      navigate(
                        `/material/${project?.material_id}/${project?.plant_id}`,
                        //   {
                        //   state: {
                        //     plant_id: project?.plant_id,
                        //     plant: project?.plant,
                        //     status: project?.plant_status,
                        //   },
                        // }
                      );
                    }}
                    style={{
                      cursor: 'pointer',
                    }}
                  >
                    <td>{project?.project_type + ' ' + project?.project_year}</td>
                    <td>{project?.project_name}</td>
                    <td>
                      {
                        // project?.fg_type === 'Virtual'
                        // ? project?.virtual_sku_description
                        // :
                        project?.sku_description
                      }
                    </td>
                    <td>
                      <Switch label="Hold" size="xs" color="yellow" checked={project?.on_hold} />
                    </td>

                    <td>{project.fg_type}</td>
                    <td>
                      {project?.production_date
                        ? moment(project?.production_date).format('MM-DD-YYYY')
                        : ''}
                    </td>
                    <td>
                      {project?.due_date_by
                        ? formatChange(project?.due_date_by)
                        : ''}
                    </td>
                    <td>{RowColors(DateDifference(project?.production_date))}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
        <Card.Footer>
          <Container>
            <Center>
              <Pagination
                total={pages + 1}
                color="yellow"
                radius="xl"
                withEdges
                page={mdmViewPagination1}
                boundaries={1}
                initialPage={mdmViewPagination1}
                value={mdmViewPagination1}
                onChange={(e) => {
                  setMdmViewPagination1(e);
                  fetchData(e, searchMdmView1, sortedColumnData, sortType);
                }}
              />
            </Center>
          </Container>
        </Card.Footer>
      </Card>
    </div>
  );
}
export default MDMView1;
